module.exports = __webpack_public_path__ + "static/media/icon-modal-non-serviceable.052430e2.svg";